import { defineComponent as _defineComponent } from 'vue';
import JobInfoChip from "@/components/Chips/JobInfoChip.vue";
import { get } from "@/client/utilities/Object";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobAutocompleteInput',
    setup(__props) {
        return { __sfc: true, JobInfoChip, get };
    }
});
